import { TextField, TextFieldVariants } from "@mui/material"

interface EditableEngagementTitleProps {
  label: string
  isReadOnly: boolean
  value: string
  symbol?: string
  size?: "small" | "medium"
  multiline?: boolean
  className?: string
  style?: React.CSSProperties
  onChange: (e: any) => void
  onSubmit: () => void
  onDoubleClick: () => void
  onCancel: () => void
  variant?: TextFieldVariants
}

const EditableEngagementTitle = (props: EditableEngagementTitleProps) => {
  const {
    label,
    value,
    isReadOnly,
    onChange,
    size = "small",
    multiline = false,
    className,
    style,
    onSubmit,
    onDoubleClick,
    onCancel,
    variant = "outlined",
  } = props

  return (
    <>
      <TextField
        inputRef={(input) => input && input.focus()}
        size={size}
        className={`ms-2 ${className}`}
        style={style}
        fullWidth={false}
        multiline={multiline}
        label={label}
        value={value}
        onChange={onChange}
        type={"text"}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            onSubmit()
          }
          if (e.key === "Escape") {
            e.preventDefault()
            onCancel()
          }
        }}
        variant={variant}
        minRows={4}
        sx={{
          display: "inline-flex",
          opacity: isReadOnly ? 0.7 : 1,
          width: "fit-content",
          maxWidth: "100%",

          "& .MuiInputBase-root": {
            alignItems: "center",
          },

          "& .MuiInputAdornment-root": {
            height: "100%",
            display: "flex",
            alignItems: "center",
            marginTop: 0,
            marginBottom: 0,
          },

          "& .MuiInputAdornment-root .MuiSvgIcon-root": {
            display: "block",
            lineHeight: 1,
          },

          "& .MuiInputBase-input": {
            width: `calc(${Math.max(value.length, 1)} * .95ch + 10px)`,
            paddingLeft: "10px",
            whiteSpace: "nowrap",
            minWidth: 1,
            WebkitTextFillColor: "#845adf",
            fontSize: "1.4rem",
            fontWeight: 500,
            paddingTop: 0,
            paddingBottom: 0,
          },

          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#845adf",
          },
        }}
        InputProps={{
          readOnly: isReadOnly,
          disableUnderline: true,
          onDoubleClick: onDoubleClick,
        }}
      />
    </>
  )
}

export default EditableEngagementTitle
